module.exports = __webpack_public_path__ + "media/images/countryrect/cornwall-9ca80b7cd33186ca5535c4554441467a.svg";